import { useTheme } from '@emotion/react'

const GooglePayButtonLogoDark = () => {
  return (
    <svg width="523" height="206" viewBox="0 0 523 206" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M244.1 99.8004V160.3H224.9V10.9004H275.8C288.7 10.9004 299.7 15.2004 308.7 23.8004C317.9 32.4004 322.5 42.9004 322.5 55.3004C322.5 68.0004 317.9 78.5004 308.7 87.0004C299.8 95.5004 288.8 99.7004 275.8 99.7004H244.1V99.8004ZM244.1 29.3004V81.4004H276.2C283.8 81.4004 290.2 78.8004 295.2 73.7004C300.3 68.6004 302.9 62.4004 302.9 55.4004C302.9 48.5004 300.3 42.4004 295.2 37.3004C290.2 32.0004 283.9 29.4004 276.2 29.4004H244.1V29.3004Z"
        fill="black"
      />
      <path
        d="M372.7 54.7012C386.9 54.7012 398.1 58.5012 406.3 66.1012C414.5 73.7012 418.6 84.1012 418.6 97.3012V160.301H400.3V146.101H399.5C391.6 157.801 381 163.601 367.8 163.601C356.5 163.601 347.1 160.301 339.5 153.601C331.9 146.901 328.1 138.601 328.1 128.601C328.1 118.001 332.1 109.601 340.1 103.401C348.1 97.1012 358.8 94.0012 372.1 94.0012C383.5 94.0012 392.9 96.1012 400.2 100.301V95.9012C400.2 89.2012 397.6 83.6012 392.3 78.9012C387 74.2012 380.8 71.9012 373.7 71.9012C363 71.9012 354.5 76.4012 348.3 85.5012L331.4 74.9012C340.7 61.4012 354.5 54.7012 372.7 54.7012ZM347.9 128.901C347.9 133.901 350 138.101 354.3 141.401C358.5 144.701 363.5 146.401 369.2 146.401C377.3 146.401 384.5 143.401 390.8 137.401C397.1 131.401 400.3 124.401 400.3 116.301C394.3 111.601 386 109.201 375.3 109.201C367.5 109.201 361 111.101 355.8 114.801C350.5 118.701 347.9 123.401 347.9 128.901Z"
        fill="black"
      />
      <path
        d="M523.001 58L459.001 205.2H439.201L463.001 153.7L420.801 58H441.701L472.101 131.4H472.501L502.101 58H523.001Z"
        fill="black"
      />
      <path
        d="M167.73 87.5999C167.73 81.3399 167.17 75.3498 166.13 69.5898H85.6504V102.59L132 102.6C130.12 113.58 124.07 122.94 114.8 129.18V150.59H142.39C158.5 135.68 167.73 113.64 167.73 87.5999Z"
        fill="#4285F4"
      />
      <path
        d="M114.809 129.179C107.129 134.359 97.2394 137.389 85.6694 137.389C63.3194 137.389 44.3594 122.329 37.5694 102.029H9.10938V124.109C23.2094 152.089 52.1894 171.289 85.6694 171.289C108.809 171.289 128.249 163.679 142.399 150.579L114.809 129.179Z"
        fill="#34A853"
      />
      <path
        d="M34.89 85.6497C34.89 79.9497 35.84 74.4397 37.57 69.2597V47.1797H9.10999C3.27999 58.7497 0 71.8097 0 85.6497C0 99.4897 3.28999 112.55 9.10999 124.12L37.57 102.04C35.84 96.8597 34.89 91.3497 34.89 85.6497Z"
        fill="#FABB05"
      />
      <path
        d="M85.6694 33.9C98.2994 33.9 109.609 38.25 118.539 46.75L142.989 22.32C128.139 8.49001 108.779 0 85.6694 0C52.1994 0 23.2094 19.2 9.10938 47.18L37.5694 69.26C44.3594 48.96 63.3194 33.9 85.6694 33.9Z"
        fill="#E94235"
      />
    </svg>
  )
}

const GooglePayButtonLogoLight = () => {
  return (
    <svg width="63" height="24" viewBox="0 0 63 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.4512 11.673V18.7491H27.1904V1.27539H33.1839C34.7029 1.27539 35.9982 1.77832 37.0579 2.78416C38.1412 3.79001 38.6829 5.01808 38.6829 6.46837C38.6829 7.95375 38.1412 9.18182 37.0579 10.176C36.01 11.1701 34.7147 11.6613 33.1839 11.6613H29.4512V11.673ZM29.4512 3.42744V9.521H33.231C34.1259 9.521 34.8795 9.2169 35.4683 8.62041C36.0688 8.02392 36.375 7.29878 36.375 6.48006C36.375 5.67305 36.0688 4.9596 35.4683 4.36311C34.8795 3.74323 34.1377 3.43913 33.231 3.43913H29.4512V3.42744Z"
        fill="white"
      />
      <path
        d="M44.594 6.39844C46.266 6.39844 47.5848 6.84288 48.5504 7.73177C49.516 8.62066 49.9987 9.83703 49.9987 11.3809V18.7493H47.8439V17.0885H47.7497C46.8195 18.4569 45.5713 19.1353 44.017 19.1353C42.6864 19.1353 41.5796 18.7493 40.6846 17.9657C39.7897 17.1821 39.3423 16.2113 39.3423 15.0417C39.3423 13.8019 39.8133 12.8195 40.7553 12.0943C41.6973 11.3575 42.9572 10.9949 44.5233 10.9949C45.8657 10.9949 46.9725 11.2405 47.8321 11.7318V11.2171C47.8321 10.4335 47.526 9.77855 46.9019 9.22884C46.2778 8.67914 45.5478 8.41013 44.7117 8.41013C43.4518 8.41013 42.4509 8.93645 41.7209 10.0008L39.7309 8.76101C40.8259 7.18206 42.4509 6.39844 44.594 6.39844ZM41.6738 15.0768C41.6738 15.6616 41.921 16.1528 42.4274 16.5388C42.9219 16.9247 43.5107 17.1236 44.1819 17.1236C45.1356 17.1236 45.9834 16.7727 46.7253 16.0709C47.4671 15.3692 47.8439 14.5505 47.8439 13.6031C47.1374 13.0534 46.1601 12.7727 44.9001 12.7727C43.9817 12.7727 43.2163 12.9949 42.604 13.4277C41.9799 13.8838 41.6738 14.4335 41.6738 15.0768Z"
        fill="white"
      />
      <path
        d="M62.2919 6.7832L54.7559 23.9996H52.4244L55.2269 17.9762L50.2578 6.7832H52.7188L56.2984 15.368H56.3455L59.8309 6.7832H62.2919Z"
        fill="white"
      />
      <path
        d="M20.4587 10.2451C20.4587 9.51294 20.3927 8.81236 20.2703 8.13867H10.7937V11.9983L16.2514 11.9995C16.0301 13.2837 15.3177 14.3784 14.2261 15.1083V17.6123H17.4749C19.3718 15.8685 20.4587 13.2907 20.4587 10.2451Z"
        fill="#4285F4"
      />
      <path
        d="M14.2273 15.109C13.3229 15.7149 12.1584 16.0693 10.796 16.0693C8.16427 16.0693 5.93172 14.3079 5.13219 11.9336H1.78101V14.5161C3.44129 17.7886 6.85371 20.0342 10.796 20.0342C13.5208 20.0342 15.8098 19.1441 17.476 17.612L14.2273 15.109Z"
        fill="#34A853"
      />
      <path
        d="M4.81657 10.017C4.81657 9.35032 4.92843 8.70588 5.13214 8.10003V5.51758H1.78096C1.09447 6.87079 0.708252 8.39828 0.708252 10.017C0.708252 11.6357 1.09565 13.1632 1.78096 14.5164L5.13214 11.9339C4.92843 11.3281 4.81657 10.6837 4.81657 10.017Z"
        fill="#FABB05"
      />
      <path
        d="M10.796 3.96491C12.2832 3.96491 13.615 4.47368 14.6665 5.46783L17.5455 2.61052C15.7969 0.992982 13.5172 0 10.796 0C6.85488 0 3.44129 2.24561 1.78101 5.51812L5.13219 8.10058C5.93172 5.72631 8.16427 3.96491 10.796 3.96491Z"
        fill="#E94235"
      />
    </svg>
  )
}

export const GooglePayLogo = () => {
  const { darkMode } = useTheme()

  return darkMode ? <GooglePayButtonLogoDark /> : <GooglePayButtonLogoLight />
}
